export type Language = 'uk' | 'en';

/**
 * All translatable UI strings, keyed by language → key → value.
 */
export const TRANSLATIONS = {
  uk: {
    // Timer
    battleIn: 'БИТВА ЧЕРЕЗ',
    finalBattleIn: 'ФІНАЛЬНА БИТВА ЧЕРЕЗ',
    sacrifice: 'ПОЖЕРТВА',
    battleToday: 'СЬОГОДНІ БИТВА!',
    finalBattleToday: 'СЬОГОДНІ ФІНАЛЬНА БИТВА!',
    firstBattleEvent: 'ПЕРША БИТВА',
    finalBattleEvent: 'ФІНАЛЬНА БИТВА',
    sacrificeEvent: 'ПОЖЕРТВА БОГАМ',

    // Battle schedule modal
    battleSchedule: 'РОЗКЛАД БИТВ',
    firstBattle: 'Перша битва',
    finalBattle: 'Фінальна битва',
    sacrificeTime: 'Час пожертв богам',
    day22: '22 число',
    day7: '7 число',
    days8to12: '8-12 числа',
    currentPhase: 'ЗАРАЗ',

    // Stats modal
    thisMonth: 'ЦЕЙ МІСЯЦЬ',
    coinsSpent: 'МОНЕТ ВИТРАЧЕНО',
    coinsWonFirstBattle: 'ЗДОБУТО В ПЕРШІЙ БИТВІ',
    coinsWonFinalBattle: 'ЗДОБУТО В ФІНАЛЬНІЙ БИТВІ',
    coinsSpentWeapons: 'ВИТРАЧЕНО НА ЗБРОЮ',

    // Payment modal
    payment: 'ОПЛАТА',
    sacrificeChoiceTitle: 'Оберіть тип пожертви',
    sacrificeWarningNote: "Пам'ятайте - боги більше люблять капусту та зірки",
    amountToSacrifice: 'СУМА ПОЖЕРТВИ:',
    sacrificeMadeBtn: 'ПОЖЕРТВУ ЗРОБЛЕНО',
    coinsSacrificeNote: 'монети треба жертвувати якщо у вас є прямий контакт з богами',
    cabbageSacrificeNote: 'капусту треба жертвувати через вівтар, що знаходиться в далеких землях за кордоном через жреця Свіфта',
    starsSacrificeNote: 'зірки треба жертвувати через вівтар, що знаходиться в далеких землях за кордоном через жреця Свіфта',
    tokensSacrificeNote: "токени треба жертвувати через великого бога Б'янца",
    youHaveToPay: 'ВАМ ПОТРІБНО СПЛАТИТИ:',
    howDidYouPay: 'ЯК ВИ СПЛАТИЛИ?',
    coins: '🪙 МОНЕТИ',
    cabbage: '🥬 КАПУСТА',
    stars: '⭐ ЗІРКИ',
    tokens: '🔹 ТОКЕНИ',

    // Buttons & common
    close: 'ЗАКРИТИ',
    ok: 'ОК',
    retry: 'ПОВТОРИТИ',
    cancel: 'СКАСУВАТИ',
    back: 'НАЗАД',

    // Logout
    logoutBtn: 'ВИХІД',
    logoutTitle: 'ВИХІД З ГРИ',
    logoutConfirm: 'Ви впевнені, що хочете вийти з акаунту гри?',
    infoLogoutItem: 'Вихід з гри — в лівому верхньому куті',

    // Payment states
    submitted: 'НАДІСЛАНО',
    paymentSubmitted: 'Платіж надіслано.',
    waitingConfirmation: 'Очікування підтвердження...',

    // Canvas text
    waiting: 'ОЧІКУВАННЯ...',
    tap: 'ЖЕРТВА',

    // Loading & errors
    loading: 'Завантаження...',
    ohNo: 'ОЙ НІ!',
    connectionLost: 'Вікінги втратили зв\'язок з сільським бухгалтером.',
    notViking: 'Ви не один з Вікінгів.',

    // Password / Auth modal
    enterPassword: 'ВВЕДІТЬ ПАРОЛЬ',
    passwordPrompt: 'Введіть ваш пароль для входу у гру:',
    passwordPlaceholder: 'ПАРОЛЬ (КОД)',
    loginBtn: 'УВІЙТИ',
    valhallaWarning: 'тільки обрані потраплять у Вальгалу, але ти не один із них',
    dragonHint: 'Торкніться дракона',

    // Info modal & help
    infoBtn: 'ІНФО',
    infoTitle: 'ДОПОМОГА ГРАВЦЮ',
    infoIntro: 'Для того щоб отримати інформацію — ви можете натискати на всі елементи гри:',
    infoHelpItem: 'Допомога гравцю — кнопка посередині зверху',
    infoLangItem: 'Перемикач мов — в правому верхньому куті',
    infoTimerItem: 'Таймер битв та пожертв внизу екрану — показує розклад битв та пожертв',
    infoHeroItem: 'Кожен персонаж — показує суму награбованого в битвах',
    infoCoinItem: 'Монетка пожертв над головами персонажів (коли з\'являється) — дає змогу побачити суму пожертв, що розраховують жерці та способи принесення жертви. Також в цьому вікні можна відмітити що жертва відправлена, й монетка змінить свій стан. Якщо жертва прийнята — запуститься таймер наступної битви.',
    infoTipHeader: 'ПАМ\'ЯТАЙ!',
    infoTipText: 'Зірочками та капустою — завжди жертвувати вигідніше — боги люблять їх більше.',
  },
  en: {
    // Timer
    battleIn: 'BATTLE IN',
    finalBattleIn: 'FINAL BATTLE IN',
    sacrifice: 'SACRIFICE',
    battleToday: 'BATTLE TODAY!',
    finalBattleToday: 'FINAL BATTLE TODAY!',
    firstBattleEvent: 'FIRST BATTLE',
    finalBattleEvent: 'FINAL BATTLE',
    sacrificeEvent: 'SACRIFICE TO GODS',

    // Battle schedule modal
    battleSchedule: 'BATTLE SCHEDULE',
    firstBattle: 'First Battle',
    finalBattle: 'Final Battle',
    sacrificeTime: 'Sacrifice to the Gods',
    day22: '22nd',
    day7: '7th',
    days8to12: '8th-12th',
    currentPhase: 'NOW',

    // Stats modal
    thisMonth: 'THIS MONTH',
    coinsSpent: 'COINS SPENT',
    coinsWonFirstBattle: 'WON IN FIRST BATTLE',
    coinsWonFinalBattle: 'WON IN FINAL BATTLE',
    coinsSpentWeapons: 'SPENT ON WEAPONS',

    // Payment modal
    payment: 'PAYMENT',
    sacrificeChoiceTitle: 'Choose sacrifice type',
    sacrificeWarningNote: 'Remember - gods love cabbage and stars more',
    amountToSacrifice: 'AMOUNT TO SACRIFICE:',
    sacrificeMadeBtn: 'SACRIFICE MADE',
    coinsSacrificeNote: 'coins should be sacrificed if you have direct contact with the gods',
    cabbageSacrificeNote: 'cabbage must be sacrificed via the altar in faraway lands abroad through the priest Svift',
    starsSacrificeNote: 'stars must be sacrificed via the altar in faraway lands abroad through the priest Svift',
    tokensSacrificeNote: "tokens must be sacrificed through the great god Biance",
    youHaveToPay: 'YOU HAVE TO PAY:',
    howDidYouPay: 'HOW DID YOU PAY?',
    coins: '🪙 COINS',
    cabbage: '🥬 CABBAGE',
    stars: '⭐ STARS',
    tokens: '🔹 TOKENS',

    // Buttons & common
    close: 'CLOSE',
    ok: 'OK',
    retry: 'RETRY',
    cancel: 'CANCEL',
    back: 'BACK',

    // Logout
    logoutBtn: 'LOGOUT',
    logoutTitle: 'LOGOUT',
    logoutConfirm: 'Are you sure you want to log out of your game account?',
    infoLogoutItem: 'Game logout — in the top-left corner',

    // Payment states
    submitted: 'SUBMITTED',
    paymentSubmitted: 'Payment submitted.',
    waitingConfirmation: 'Waiting for confirmation...',

    // Canvas text
    waiting: 'WAITING...',
    tap: 'TAP',

    // Loading & errors
    loading: 'Loading...',
    ohNo: 'OH NO!',
    connectionLost: 'The Vikings lost connection to the village accountant.',
    notViking: 'You are not one of the Vikings.',

    // Password / Auth modal
    enterPassword: 'ENTER PASSWORD',
    passwordPrompt: 'Enter your password to enter the game:',
    passwordPlaceholder: 'PASSWORD (CODE)',
    loginBtn: 'ENTER',
    valhallaWarning: 'Only the chosen will enter Valhalla, but you are not one of them',
    dragonHint: 'Tap the dragon',

    // Info modal & help
    infoBtn: 'INFO',
    infoTitle: 'PLAYER GUIDE',
    infoIntro: 'To get information, you can tap on all game elements:',
    infoHelpItem: 'Player help — center button at the top',
    infoLangItem: 'Language toggle — in the top-right corner',
    infoTimerItem: 'Battle & sacrifice timer at the bottom — shows the battle and sacrifice schedule',
    infoHeroItem: 'Each character — shows the amount looted in battles',
    infoCoinItem: 'Sacrifice coin above characters (when it appears) — allows viewing the sacrifice amount calculated by the priests and payment methods. You can also confirm the sacrifice was sent to change the coin state. Once accepted, the next battle countdown begins.',
    infoTipHeader: 'REMEMBER!',
    infoTipText: 'Sacrificing with Stars and Cabbage is always more profitable — the gods love them more.',
  },
} as const;

export type TranslationKey = keyof typeof TRANSLATIONS['en'];

/**
 * Get a translated string for the given language and key.
 */
export function t(lang: Language, key: TranslationKey): string {
  return TRANSLATIONS[lang][key];
}
